import { format } from 'date-fns';
import { CART_FORMAT_DATE } from '@/service/constants/dates';
import { newDateFromString } from './getDateByTimezone';

export const formattedDate = (date: string, time?: string, dataFormat?: string) =>
    `${format(newDateFromString(date), dataFormat || CART_FORMAT_DATE)} ${time ? `@ ${time}` : ''}`;
